/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PaginatedPurchaseList } from '../models/paginated-purchase-list';
import { Purchase } from '../models/purchase';
import { purchasesConfirmPayment } from '../fn/purchases/purchases-confirm-payment';
import { PurchasesConfirmPayment$Params } from '../fn/purchases/purchases-confirm-payment';
import { purchasesList } from '../fn/purchases/purchases-list';
import { PurchasesList$Params } from '../fn/purchases/purchases-list';
import { purchasesPartialUpdate } from '../fn/purchases/purchases-partial-update';
import { PurchasesPartialUpdate$Params } from '../fn/purchases/purchases-partial-update';
import { purchasesRetrieve } from '../fn/purchases/purchases-retrieve';
import { PurchasesRetrieve$Params } from '../fn/purchases/purchases-retrieve';
import { purchasesStartPayment } from '../fn/purchases/purchases-start-payment';
import { PurchasesStartPayment$Params } from '../fn/purchases/purchases-start-payment';
import { purchasesUpdate } from '../fn/purchases/purchases-update';
import { PurchasesUpdate$Params } from '../fn/purchases/purchases-update';
import { StartPaymentResponse } from '../models/start-payment-response';

@Injectable({ providedIn: 'root' })
export class PurchasesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `purchasesList()` */
  static readonly PurchasesListPath = '/msp/api/purchases/';

  /**
   * Allows read and update on Purchases in which the authenticated User is a Customer.
   * Creation and deletion of Purchases is performed by the server, and not via the API.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `purchasesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  purchasesList$Response(params?: PurchasesList$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedPurchaseList>> {
    return purchasesList(this.http, this.rootUrl, params, context);
  }

  /**
   * Allows read and update on Purchases in which the authenticated User is a Customer.
   * Creation and deletion of Purchases is performed by the server, and not via the API.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `purchasesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  purchasesList(params?: PurchasesList$Params, context?: HttpContext): Observable<PaginatedPurchaseList> {
    return this.purchasesList$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginatedPurchaseList>): PaginatedPurchaseList => r.body)
    );
  }

  /** Path part for operation `purchasesRetrieve()` */
  static readonly PurchasesRetrievePath = '/msp/api/purchases/{id}/';

  /**
   * Allows read and update on Purchases in which the authenticated User is a Customer.
   * Creation and deletion of Purchases is performed by the server, and not via the API.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `purchasesRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  purchasesRetrieve$Response(params: PurchasesRetrieve$Params, context?: HttpContext): Observable<StrictHttpResponse<Purchase>> {
    return purchasesRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Allows read and update on Purchases in which the authenticated User is a Customer.
   * Creation and deletion of Purchases is performed by the server, and not via the API.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `purchasesRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  purchasesRetrieve(params: PurchasesRetrieve$Params, context?: HttpContext): Observable<Purchase> {
    return this.purchasesRetrieve$Response(params, context).pipe(
      map((r: StrictHttpResponse<Purchase>): Purchase => r.body)
    );
  }

  /** Path part for operation `purchasesUpdate()` */
  static readonly PurchasesUpdatePath = '/msp/api/purchases/{id}/';

  /**
   * Allows read and update on Purchases in which the authenticated User is a Customer.
   * Creation and deletion of Purchases is performed by the server, and not via the API.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `purchasesUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  purchasesUpdate$Response(params: PurchasesUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<Purchase>> {
    return purchasesUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Allows read and update on Purchases in which the authenticated User is a Customer.
   * Creation and deletion of Purchases is performed by the server, and not via the API.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `purchasesUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  purchasesUpdate(params: PurchasesUpdate$Params, context?: HttpContext): Observable<Purchase> {
    return this.purchasesUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<Purchase>): Purchase => r.body)
    );
  }

  /** Path part for operation `purchasesPartialUpdate()` */
  static readonly PurchasesPartialUpdatePath = '/msp/api/purchases/{id}/';

  /**
   * Allows read and update on Purchases in which the authenticated User is a Customer.
   * Creation and deletion of Purchases is performed by the server, and not via the API.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `purchasesPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  purchasesPartialUpdate$Response(params: PurchasesPartialUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<Purchase>> {
    return purchasesPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Allows read and update on Purchases in which the authenticated User is a Customer.
   * Creation and deletion of Purchases is performed by the server, and not via the API.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `purchasesPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  purchasesPartialUpdate(params: PurchasesPartialUpdate$Params, context?: HttpContext): Observable<Purchase> {
    return this.purchasesPartialUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<Purchase>): Purchase => r.body)
    );
  }

  /** Path part for operation `purchasesConfirmPayment()` */
  static readonly PurchasesConfirmPaymentPath = '/msp/api/purchases/{id}/confirm_payment/';

  /**
   * Marks Purchase as paid. Also all its OrderProducts with status 'DRAFT' switch status to 'PAID'.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `purchasesConfirmPayment()` instead.
   *
   * This method doesn't expect any request body.
   */
  purchasesConfirmPayment$Response(params: PurchasesConfirmPayment$Params, context?: HttpContext): Observable<StrictHttpResponse<Purchase>> {
    return purchasesConfirmPayment(this.http, this.rootUrl, params, context);
  }

  /**
   * Marks Purchase as paid. Also all its OrderProducts with status 'DRAFT' switch status to 'PAID'.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `purchasesConfirmPayment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  purchasesConfirmPayment(params: PurchasesConfirmPayment$Params, context?: HttpContext): Observable<Purchase> {
    return this.purchasesConfirmPayment$Response(params, context).pipe(
      map((r: StrictHttpResponse<Purchase>): Purchase => r.body)
    );
  }

  /** Path part for operation `purchasesStartPayment()` */
  static readonly PurchasesStartPaymentPath = '/msp/api/purchases/{id}/start_payment/';

  /**
   * Allows read and update on Purchases in which the authenticated User is a Customer.
   * Creation and deletion of Purchases is performed by the server, and not via the API.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `purchasesStartPayment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  purchasesStartPayment$Response(params: PurchasesStartPayment$Params, context?: HttpContext): Observable<StrictHttpResponse<StartPaymentResponse>> {
    return purchasesStartPayment(this.http, this.rootUrl, params, context);
  }

  /**
   * Allows read and update on Purchases in which the authenticated User is a Customer.
   * Creation and deletion of Purchases is performed by the server, and not via the API.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `purchasesStartPayment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  purchasesStartPayment(params: PurchasesStartPayment$Params, context?: HttpContext): Observable<StartPaymentResponse> {
    return this.purchasesStartPayment$Response(params, context).pipe(
      map((r: StrictHttpResponse<StartPaymentResponse>): StartPaymentResponse => r.body)
    );
  }

}
